import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SpatialInformationPortalComponent } from './spatial-information-portal.component';

const routes: Routes = [
  {
    path: 'spatial-information-portal',
    component: SpatialInformationPortalComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpatialInformationPortalRoutingModule {}
